export const generateRandomId = () => Math.floor(Math.random() * 100);